{
  "name": "frontend-pdc-workspace",
  "version": "26.11.1",
  "scripts": {
    "start": "npm-run-all clean --parallel parashift-shared:watch app-parashift-io:start-waiton",
    "start:embedded": "npm-run-all clean --parallel parashift-shared:watch embedded-parashift-io:start-waiton",
    "build": "run-s parashift-shared:build embedded-parashift-io:build app-parashift-io:build",
    "test": "run-p embedded-parashift-io:test app-parashift-io:test parashift-shared:test",
    "test-coverage": "run-p parashift-shared:test-coverage embedded-parashift-io:test-coverage app-parashift-io:test-coverage",
    "lint": "ng lint",
    "app-parashift-io:start-waiton": "wait-on dist/parashift/shared/package.json && npm run app-parashift-io:start",
    "app-parashift-io:start": "ng serve app-parashift-io",
    "app-parashift-io:build": "ng build app-parashift-io --configuration production",
    "app-parashift-io:watch": "ng build app-parashift-io --watch --configuration dev",
    "app-parashift-io:test": "ng test app-parashift-io",
    "app-parashift-io:test-coverage": "ng test app-parashift-io --code-coverage",
    "app-parashift-io:extract-i18n": "ng extract-i18n app-parashift-io --output-path projects/app-parashift-io/src/locale",
    "embedded-parashift-io:start-waiton": "wait-on dist/parashift/shared/package.json && npm run embedded-parashift-io:start",
    "embedded-parashift-io:start": "ng serve embedded-parashift-io",
    "embedded-parashift-io:build": "ng build embedded-parashift-io",
    "embedded-parashift-io:watch": "ng build embedded-parashift-io --watch --configuration dev",
    "embedded-parashift-io:test": "ng test embedded-parashift-io",
    "embedded-parashift-io:test-coverage": "ng test embedded-parashift-io --code-coverage",
    "parashift-shared:build": "ng build @parashift/shared",
    "parashift-shared:watch": "ng build @parashift/shared --watch --configuration production",
    "parashift-shared:test": "ng test @parashift/shared",
    "parashift-shared:test-coverage": "ng test @parashift/shared --code-coverage",
    "clean": "rimraf dist",
    "sentry:app-parashift-io": "sh sentry/app-parashift-io.artifacts.sh",
    "sentry:embedded-parashift-io": "sh sentry/embedded-parashift-io.artifacts.sh"
  },
  "private": true,
  "dependencies": {
    "@acrodata/code-editor": "^0.6.1",
    "@angular-slider/ngx-slider": "^20.0.0",
    "@angular/animations": "^20.3.34",
    "@angular/common": "^20.3.34",
    "@angular/compiler": "^20.3.34",
    "@angular/core": "^20.3.34",
    "@angular/elements": "^20.3.34",
    "@angular/forms": "^20.3.34",
    "@angular/platform-browser": "^20.3.34",
    "@angular/platform-browser-dynamic": "^20.3.34",
    "@angular/router": "^20.3.34",
    "@codemirror/lang-json": "^6.0.2",
    "@codemirror/language": "^6.13.1",
    "@codemirror/lint": "^6.9.7",
    "@codemirror/state": "^6.7.6",
    "@codemirror/view": "^6.43.15",
    "@fortawesome/angular-fontawesome": "~3.0.0",
    "@fortawesome/fontawesome-pro": "^7.2.0",
    "@fortawesome/fontawesome-svg-core": "^7.2.0",
    "@fortawesome/pro-duotone-svg-icons": "^7.2.0",
    "@fortawesome/pro-light-svg-icons": "^7.2.0",
    "@fortawesome/pro-regular-svg-icons": "^7.2.0",
    "@fortawesome/pro-solid-svg-icons": "^7.2.0",
    "@lezer/highlight": "^1.2.5",
    "@maskito/angular": "^5.1.1",
    "@maskito/core": "^5.1.1",
    "@maskito/kit": "^5.1.1",
    "@ngx-formly/bootstrap": "^7.1.0",
    "@ngx-formly/core": "^7.1.0",
    "@parashift/ngx-airbrush": "^15.1.0",
    "@parashift/ngx-bootstrap-multiselect": "15.0.0",
    "@popperjs/core": "^2.11.8",
    "@sentry/angular": "^10.39.0",
    "@sqlite.org/sqlite-wasm": "^3.51.2-build6",
    "activestorage": "^5.2.8-1",
    "animate.css": "^4.1.1",
    "bootstrap": "^5.3.8",
    "chart.js": "4.5.1",
    "color": "4.2.3",
    "core-js": "^3.26.1",
    "date-fns": "^3.6.0",
    "date-fns-tz": "^3.1.3",
    "fuzziersort": "^4.0.1",
    "iso-639-1": "^2.1.9",
    "jwt-decode": "^4.0.0",
    "lodash": "^4.18.1",
    "ng-keyboard-shortcuts": "13.0.8",
    "ngx-bootstrap": "^20.0.2",
    "ngx-clipboard": "^16.0.0",
    "ngx-device-detector": "^10.1.0",
    "ngx-drag-drop": "^20.0.1",
    "ngx-image-cropper": "^9.1.6",
    "ngx-toastr": "^20.0.5",
    "pace-js": "^1.2.4",
    "pdfjs-dist": "^6.3.289",
    "reflect-metadata": "^0.2.2",
    "rxjs": "~7.8.0",
    "trusted-types": "^2.0.0",
    "tslib": "^2.3.0",
    "userflow.js": "2.1.2",
    "uuid": "^13.0.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.3.41",
    "@angular/cli": "^20.3.41",
    "@angular/compiler-cli": "^20.3.34",
    "@angular/localize": "^20.3.34",
    "@sentry/cli": "^3.8.2",
    "@types/activestorage": "^5.2.7",
    "@types/color": "^3.0.6",
    "@types/core-js": "^2.5.8",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^20.14.12",
    "@types/trusted-types": "^2.0.7",
    "@types/wicg-entries-api": "^2020.8.2",
    "angular-eslint": "^20.7.0",
    "eslint": "^9.19.0",
    "eslint-plugin-deprecation": "^3.0.0",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ng-packagr": "^20.3.2",
    "npm-run-all": "^4.1.5",
    "rimraf": "^6.0.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.72.1",
    "wait-on": "^8.0.0"
  },
  "engines": {
    "node": "^24.13"
  }
}
